import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import Bouton from '../Bouton/Bouton';
import styles from './Popup.module.scss';

const affichagePetit = '5.9% 0.1% 0% 15.2%';
const affichageGrand = '0% 0% 0% 0%';

const Popup = ({
  showModal: showModalProp,
  afficherVueConnexion,
  identifier,
  afficherExpand: afficherExpandProp,
  width,
  popup_id,
  barre_outils,
  sansBouton,
  afficherLien,
  eventAuClique,
  eventALaFermeture,
  icone,
  texte_ouverture,
  hoverText,
  typeBoutonAffichage,
  desactive,
  textAlignLeftBouton,
  children,
}) => {
  const [showModal, setShowModal] = useState(
    showModalProp !== undefined
      ? showModalProp
      : false || (afficherVueConnexion === true && identifier)
  );
  const [overflowX, setOverflowX] = useState('auto');
  const [overflowY, setOverflowY] = useState('hidden');
  const [inset, setInset] = useState(
    afficherExpandProp ? affichageGrand : affichagePetit
  );
  const [afficherExpand, setAfficherExpand] = useState(afficherExpandProp);

  useEffect(() => {
    if (width === '100%') {
      setInset('5.9% 0.1% 0% 0%');
    } else {
      setInset('5.9% 0.1% 0% 15.2%');
    }
  }, [width]);

  const toggleShowModal = () => {
    setShowModal(!showModal);
  };

  const closeModal = () => {
    setShowModal(false);
    if (eventALaFermeture && typeof eventALaFermeture === 'function') {
      eventALaFermeture();
    }
  };

  const setExpand = () => {
    setInset('0% 0% 0% 0%');
    setAfficherExpand(true);
    setOverflowX('hidden');
    if (document.getElementById(popup_id)) {
      document.getElementById(popup_id).requestFullscreen();
    }
  };

  const setPetit = () => {
    setInset(affichagePetit);
    setAfficherExpand(false);
    setOverflowX('auto');
    setOverflowY('auto');
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const classpopup = [styles.boutonOutilPopup, s.row, s.text_right];
  const boutonExpand = afficherExpand ? (
    <Bouton
      ajoutClass={[styles.BoutonOutil].join(' ')}
      type={type_btn.Min}
      rond={true}
      cliquer={setPetit}
    />
  ) : (
    <Bouton
      ajoutClass={[styles.BoutonOutil].join(' ')}
      type={type_btn.Max}
      rond={true}
      cliquer={setExpand}
    />
  );

  const barreOutils = (
    <div className={classpopup.join(' ')}>
      <Bouton
        ajoutClass={[styles.BoutonOutil].join(' ')}
        type={type_btn.fermer}
        rond={true}
        cliquer={closeModal}
      />
      {boutonExpand}
      {barre_outils}
    </div>
  );

  const classBouton = textAlignLeftBouton ? styles.formatLeft : styles.format;

  let openButton;
  if (sansBouton) {
    openButton = null;
  } else if (afficherLien) {
    openButton = (
      <button
        type="button"
        className={styles.linkButton}
        onClick={(event) => {
          event.preventDefault();
          toggleShowModal();
          if (eventAuClique && typeof eventAuClique === 'function') {
            eventAuClique();
          }
        }}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: 'inherit',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        {icone}
        {texte_ouverture}
      </button>
    );
  } else {
    openButton = (
      <Bouton
        hoverText={hoverText}
        ajoutClass={classBouton}
        type={typeBoutonAffichage}
        desactive={desactive === true}
        cliquer={() => {
          toggleShowModal();
          if (eventAuClique && typeof eventAuClique === 'function') {
            eventAuClique();
          }
        }}
      >
        {icone}
        {texte_ouverture}
      </Bouton>
    );
  }

  return (
    <div className={styles.divMaster3}>
      {openButton}
      <Modal
        id={popup_id}
        isOpen={showModal || showModalProp === true}
        onRequestClose={closeModal}
        style={{
          overlay: {
            position: 'absolute',
            zIndex: '1000',
            border: 'black 1px solid',
            backgroundColor: 'transparent',
            transition: 'width 2s, height 4s',
          },
          content: {
            overflowX,
            overflowY,
            inset,
            padding: '0px',
            boxShadow: '-5px 0px 5px rgba(0, 0, 0, 0.226)',
          },
        }}
      >
        {barreOutils}
        {children}
      </Modal>
    </div>
  );
};

export default Popup;
